e360.directive('disableLinebreak', [
   function () {
      return {
         restrict: 'A',
         link: function(scope, element, attrs) {
            element.keypress(function(e) {
               if (event.which == '13') {
                  return false;
               }
            });
         }
      };
   }
]);
